import {lazy} from 'react';

export const SectionWithRestrictedAccessLazy = lazy(() => import(/* webpackChunkName: "sectionWithRestrictedAccess" */ '.'));
